import {html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {classMap} from 'lit/directives/class-map.js';
import {when} from 'lit/directives/when.js';
import {
	AttributeInterpreter,
	AttributeType,
	ChoiceValueDecisionState,
	ChoiceValueInterpreter,
	ConfigurationInterpreter
} from '@viamedici-spc/configurator-ts';

import {staggeredReveal} from '../../css/styleSets';
import {SpcBaseValue} from './spcBaseValue';
import radio from '../../../icons/radio';
import radioChecked from '../../../icons/radio-checked';
import {pimText} from '../../util/values';

@customElement('spc-assistant-choice-value')
export class SpcAssistantChoiceValue extends SpcBaseValue {

	static styles = [
		staggeredReveal,
		css`
			:host {
			}

			.item {
				background: var(--color-widget-background);
				color: var(--color-widget-text);
				display: flex;
				flex-direction: column;
				gap: 10px;
				padding: 16px;
				cursor: pointer;
				transition: background-color 0.4s ease-out, color 0.4s ease-out;
			}
			.item.selected {
				background: var(--color-widget-background-selected-dark);
			}
			.item:hover {
				background: var(--color-widget-background-hover);
			}
			.item.selected:hover {
				background: var(--color-widget-background-selected-dark);
			}
			.label {
				font: var(--font-widget-big-label);
				color: var(--color-widget-text);
				display: flex;
				flex-direction: row;
				position: relative;
				justify-content: space-between;
			}
			.labeltext {

			}
			.icon {

			}
			.description {
				font: var(--font-widget-info);
				color: var(--color-widget-info);
				line-height: 1.4;
				opacity: 0;
				animation: reveal 0.25s ease-out 0s 1 normal forwards;
			}
			@keyframes reveal {
				from {
					opacity: 0;
				}

				to {
					opacity: 100%;
				}
			}

			.selected button {
				color: var(--color-text-widget-active);
				border: var(--border-widget-active);
				background-color: var(--color-background-widget-active);
			}

			.fixed button {
				border: var(--border-widget-fixed);
				pointer-events: none;
			}

			.disabled button {
				color: var(--color-grey6);
				border-color: var(--color-grey6);
				pointer-events: none;
			}

			.disabled button:hover {
				color: var(--color-white);
			}

			.disabled.hideDisabled button {
				display: none
			}

			.icon {
				display: inline-block;
			}

			.icon svg {
				display: block;
			}
        `];

	stateChanged(state) {
		super.stateChanged(state);

		this.attribute = ConfigurationInterpreter.getChoiceAttribute(this.spcConfiguration, this.attributeId);
		this.isMultiselect = AttributeInterpreter.isChoiceAttributeMultiSelect(this.attribute);
		this.selectedChoiceValueIds = AttributeInterpreter.getIncludedChoiceValues(this.attribute).map((a) => a.id);
		this.selectedChoiceValueId = this.selectedChoiceValueIds[0] ?? null;
		//console.log('value', this.attribute, this.selectedChoiceValueIds, this.value);
	}

	makeDecision() {
		this.session.makeDecision({
				type: AttributeType.Choice,
				attributeId: this.attributeId,
				choiceValueId: this.value.id,
				state: ChoiceValueDecisionState.Included
			}
		);
	}

	isIncluded() {
		return this.selectedChoiceValueIds.includes(this.value.id);
	}

	isAllowed() {
		return ChoiceValueInterpreter.isAllowed(this.value);
	}

	render() {
		if (!this.value) return null;
		return html`
			<div class="item ${classMap({
				selected: this.isIncluded(),
				disabled: !this.isAllowed(),
				hideDisabled: this.hideDisabled,
				fixed: !this.canBeExcluded(),
				hidden: !this.isVisible()
			})}" @click="${this.makeDecision}">

				<div class="label">
					<div class="labeltext">
						<trans-label key="${this.attributeId.localId}" value="${this.value.id}" context="FV"></trans-label>
					</div>
					${when(this.isIncluded(),
						() => html`
							<div class="icon">${radioChecked}</div>`,
						() => html`
							<div class="icon">${radio}</div>`,)
					}
				</div>
				${when(this.isIncluded() && pimText(this.lang, this.attributeId.localId, 'FV.D', this.spcConfiguration, this.translations, this.value.id) !== '', () => html`
					<div class="description">
						<trans-label key="${this.attributeId.localId}" value="${this.value.id}" context="FV.D" .showIdWhenMissing=${false}></trans-label>
					</div>
				`)}
			</div>
        `;
	}
}
